import React, { ElementType, MouseEvent, ReactNode } from 'react';
import FullWidthCard from 'src/components/cards/full-width-card';
import { mergeClasses } from 'src/stylesheets/utils';
import layout from 'src/stylesheets/layout_classes.module.scss';
import { IconRecentPurchase, IconWeeklyAd } from 'src/components/Icons';
import { Body } from 'src/components/UI';
import COLORS from 'src/lib/colors';
import { useEventsReporter } from 'src/hooks';
import styles from './style.module.scss';

interface IActionButtonProps {
    onClick: (e: any) => void;
    Icon: ReactNode;
    title: string;
}

interface IProps {
    navigateToTarget: (event: any, url: string) => void;
}

const WeeklyAdAndPurchase = ({ navigateToTarget }: IProps) => {
    const { analyticsCustomEvent } = useEventsReporter();

    const handleRecentPurchaseClick = (
        event: React.MouseEvent<HTMLDivElement, MouseEvent>
    ) => {
        analyticsCustomEvent('storemode_logged in', {
            click_text: `recent purchases`,
            element_location: 'module 3',
        });
        navigateToTarget(
            event,
            `${process.env.REACT_APP_DOT_COM_URL}/ptd/myorders`
        );
    };

    const handleWeeklyAddClick = (
        event: React.MouseEvent<HTMLDivElement, MouseEvent>
    ) => {
        analyticsCustomEvent('storemode_logged in', {
            click_text: `weekly ad`,
            element_location: 'module 4',
        });
        navigateToTarget(
            event,
            `${process.env.REACT_APP_DOT_COM_URL}/stores/weekly-ad`
        );
    };

    const ActionButtonWrapper = ({
        onClick,
        Icon,
        title,
    }: IActionButtonProps) => (
        <FullWidthCard
            className={mergeClasses(styles.card, styles.smallCard)}
            noPadding
            onClick={(event) => onClick(event)}
        >
            <div
                className={mergeClasses(
                    layout.flex,
                    layout.alignCenter,
                    layout.colGap4
                )}
            >
                {Icon}
                <Body size={14} weight="light" color={COLORS.darkGray}>
                    {title}
                </Body>
            </div>
        </FullWidthCard>
    );

    return (
        <>
            <div
                className={mergeClasses(
                    layout.flex,
                    layout.alignCenter,
                    styles.smallCardContainer
                )}
            >
                <ActionButtonWrapper
                    onClick={handleRecentPurchaseClick}
                    Icon={<IconRecentPurchase />}
                    title={'Recent purchases'}
                />
                <ActionButtonWrapper
                    onClick={handleWeeklyAddClick}
                    Icon={<IconWeeklyAd />}
                    title={'Weekly Ad'}
                />
            </div>
        </>
    );
};

export default WeeklyAdAndPurchase;
